module.exports = __webpack_public_path__ + "img/formIcon1.137c2dd7.png";